import { version } from '../package.json';
import type { GlobConfig, GlobEnvConfig } from '@star/types';

export const BASE_CONFIG = {
  appVersion: -1.0,
  appWKwebview: 0,
};

function createStorageKeyPrefix(env: Record<string, any>) {
  const { VITE_GLOB_APP_SHORT_NAME } = getAppConfig(env);
  return `${VITE_GLOB_APP_SHORT_NAME}_${env.MODE}`.toUpperCase();
}

// 根据版本生成缓存键
export function createStorageName(env: Record<string, any>) {
  return `${createStorageKeyPrefix(env)}${`_${version}`}_`.toUpperCase();
}

/**
 * 获取配置文件变量名
 * @param env
 */
export function getAppConfigFileName(env: Record<string, any>) {
  return `__PRODUCTION__${env.VITE_GLOB_APP_SHORT_NAME || '__APP'}__CONF__`.toUpperCase().replace(/\s/g, '');
}

function getAppConfig(env: Record<string, any>) {
  const ENV_NAME = getAppConfigFileName(env);

  const ENV = (
    env.DEV
      ? // 获取全局配置(打包时将独立提取配置)
        env
      : window[ENV_NAME]
  ) as GlobEnvConfig;
  const { VITE_API_DOMAIN_ADDR } = ENV;

  if (!/^[a-zA-Z\_]*$/.test(VITE_API_DOMAIN_ADDR)) {
    console.warn(
      `${VITE_API_DOMAIN_ADDR} Variables can only be characters/underscores, please modify in the environment variables and re-running.`
    );
  }

  return ENV;
}

export function getGlobalConfig(env: Record<string, any>): Readonly<GlobConfig> {
  const {
    VITE_API_PROJECT,
    VITE_THEME_NAME,
    VITE_LANG_NAME,
    VITE_API_PROXY_URL_V1,
    VITE_API_DOMAIN_ADDR,
    VITE_POST_CSS_ROOT_VALUE,
    VITE_GLOB_APP_SHORT_NAME,
  } = getAppConfig(env);

  // Take global configuration
  const glob: Readonly<GlobConfig> = {
    title: VITE_API_PROJECT,
    theme: VITE_THEME_NAME,
    language: VITE_LANG_NAME,
    apiUrl: VITE_API_PROXY_URL_V1,
    baseUrl: VITE_API_DOMAIN_ADDR,
    postCssRootValue: VITE_POST_CSS_ROOT_VALUE,
    shortName: VITE_GLOB_APP_SHORT_NAME,
  };
  return glob as Readonly<GlobConfig>;
}
